<template>
  <div class="im-card-message" :class="{ right: isMe }">
    <div class="title-wrap">
      <span class="text">{{ messageContext.name || '' }} {{ filteSex(messageContext.sex) }}</span>
    </div>
    <div class="content-list">
      <div class="content-item">
        <div class="subtitle-head">
          <div class="subtitle">
            <span class="text">症状描述</span>
          </div>
          <div class="subtitle-h3">
            <span :selectable="true" :user-select="true" class="text">
              {{ messageContext.symptomDesc }}
            </span>
          </div>
        </div>
        <div
          v-if="messageContext.tReginfoPicsList && messageContext.tReginfoPicsList.length"
          class="content"
        >
          <div class="image-content">
            <div class="images-list">
              <img
                v-for="(image, imageIndex) in messageContext.tReginfoPicsList.slice(0, 2)"
                :key="imageIndex"
                :src="outImageFullPath(image.picLink || image)"
                class="image"
                @click="onPreviewImage(imageIndex)"
              />
            </div>
            <div class="more">
              <span class="more-txt">
                {{ `共${messageContext.tReginfoPicsList.length}张` }}
              </span>
              <uni-icons type="forward" color="rgba(0, 0, 0, 0.3)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { outImageFullPath } from '@/views/funcPuzzle/utils/util.js'
import { ImagePreview } from 'vant'
export default {
  name: 'imCustomRegister',
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {
      // messageContext: {
      //   hospitalID: '26373',
      //   userID: '1501765455675703298',
      //   deptID: '10404',
      //   deptName: '康复科门诊',
      //   regDate: '2022-03-11',
      //   serviceID: 217065,
      //   serviceWay: '3',
      //   serviceName: '图文',
      //   serviceFee: 0,
      //   symptomDesc:
      //     '你好，家里有个一侧肢体偏瘫的病人，想去康复住院，有床位吗？明天上午想去住院',
      //   doctorId: '2954',
      //   doctorName: '洪玉光',
      //   tReginfoPicsList: [],
      //   paymentMode: '微信',
      //   paymentState: '1',
      //   tradeOrderNo: '1110002',
      //   channel: 'wx_lite',
      //   openid: 'oL4yJ5Ds0Q_zZzPHRpKngdL4DdAg',
      //   type: '3',
      //   schemaState: 1,
      //   timeslotName: '00:00-23:59',
      //   schemaID: 84559,
      //   classType: '04',
      //   timeslotCode: '99',
      //   patientID: '0001887290',
      //   name: '郭家幸',
      //   sex: '1',
      //   mobilePhone: '15047802360',
      //   usedAI: '0'
      // }
    }
  },
  computed: {
    isMe() {
      return this.message.flow === 'out'
    },
    messageContext() {
      const data = JSON.parse(this.message.payload.data)
      return data.content
    }
  },
  methods: {
    outImageFullPath,
    filteSex(val) {
      const hash = {
        1: '男',
        2: '女'
      }
      return hash[val] || ''
    },
    onPreviewImage(index) {
      const urls = this.messageContext.tReginfoPicsList.map(item =>
        outImageFullPath(item.picLink || item)
      )
      ImagePreview({
        images: urls,
        startPosition: index,
        closeable: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.im-card-message {
  border-radius: 0 0.597333rem 0.597333rem 0.597333rem;
  background: #ffffff;
  box-shadow: 0rem 0.128rem 0.426667rem 0rem #ebeff9;

  &.right {
    border-radius: 0.597333rem 0 0.597333rem 0.597333rem;
    .title-wrap {
      border-radius: 0.597333rem 0 0 0;
    }
  }

  .title-wrap {
    padding: 0.384rem 0.512rem;
    font-size: 0.64rem;
    line-height: 0.853333rem;
    color: #ffffff;
    background: #0089ff;
    border-radius: 0 0.597333rem 0 0;
    text-align: left;

    & > .text {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .content-list {
    padding-top: 0.256rem;
    padding-bottom: 0.256rem;

    .content-item {
      position: relative;
      padding-left: 0.512rem;
      padding-right: 0.512rem;

      // .subtitle-head {
      // border-bottom: .021333rem solid #ececec;
      // }

      .subtitle {
        display: flex;
        align-items: center;
        padding-top: 0.256rem;
        padding-bottom: 0.256rem;
        padding-left: 0.213333rem;
        color: #222222;
        font-weight: 500;
        overflow: hidden;

        &::before {
          content: '';
          margin-right: 0.213333rem;
          display: block;
          width: 0.085333rem;
          height: 0.469333rem;
          border-radius: 0.053333rem;
          background: #0089ff;
        }

        & > .text {
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .subtitle-h3 {
        padding-left: 0.512rem;
        padding-top: 0.256rem;
        padding-bottom: 0.256rem;
        display: flex;
        align-items: center;
        overflow: hidden;
        text-align: left;

        .text {
          color: #222222;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
        }

        .h3 {
          margin-right: 0.32rem;
          display: block;
          flex: 2;
          font-size: 0.64rem;
          line-height: 0.64rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .intro {
          flex: 1;
          font-size: 0.597333rem;
          line-height: 0.64rem;
          color: #888888;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        &.txt {
          padding-top: 0.512rem;
          padding-left: 0.298667rem;
          padding-bottom: 0.512rem;
          text-align: left;
          & > .text {
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .image-content {
    display: flex;
    align-items: center;
    overflow: hidden;
    border-top: 0.021333rem solid #ececec;

    .images-list {
      padding-top: 0.512rem;
      padding-bottom: 0.512rem;
      flex: 1;
      display: flex;
      overflow: hidden;

      & > .image {
        margin-right: 0.512rem;
        display: block;
        flex: 0 0 2.944rem;
        width: 2.944rem;
        height: 2.944rem;
        border-radius: 0.170667rem;
      }
    }

    .more {
      margin-left: 0.32rem;
      display: flex;
      align-items: center;
      font-size: 0.64rem;
      line-height: 0.853333rem;
      color: rgba(0, 0, 0, 0.3);

      .more-txt {
        margin-right: 0.170667rem;
        color: #222222;
      }
    }
  }
}
</style>
